import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { className: "checkmark", width: 16, height: 16, viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.5 4.5l-7 7-3-3", stroke: "currentColor", strokeWidth: 2, fill: "none" }));
export default SvgCheckmark;
